import React from "react";

type FoundryPageShellProps = {
  sidebar?: React.ReactNode;
  main: React.ReactNode;
  inspector?: React.ReactNode;
  fullHeight?: boolean;
  flush?: boolean;
  frameless?: boolean;
  sidebarWidth?: string;
  inspectorWidth?: string;
  hideSidebar?: boolean;
  showSidebarOnMobile?: boolean;
  showInspectorOnMobile?: boolean;
};

const FoundryPageShell: React.FC<FoundryPageShellProps> = ({
  sidebar,
  main,
  inspector,
  fullHeight = false,
  flush = false,
  frameless = false,
  sidebarWidth = "w-80",
  inspectorWidth = "w-96",
  hideSidebar = false,
  showSidebarOnMobile = false,
  showInspectorOnMobile = false,
}) => {
  return (
    <div
      className={[
        fullHeight ? "h-[calc(100vh-128px)]" : "min-h-0",
        "it-page-shell min-w-0 text-slate-950 transition-colors dark:text-slate-100",
      ].join(" ")}
    >
      <div
        className={[
          frameless
            ? "flex overflow-hidden bg-transparent"
            : "flex overflow-hidden border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900/60",
          fullHeight ? "h-full" : "min-h-[calc(100vh-128px)]",
          flush ? "rounded-none" : "rounded-xl",
          showSidebarOnMobile ? "flex-col lg:flex-row" : "",
        ].join(" ")}
      >
        {sidebar && !hideSidebar && (
          <aside
            className={[
              showSidebarOnMobile
                ? "shrink-0 border-b border-slate-200 bg-slate-50/70 dark:border-white/10 dark:bg-slate-950/50 lg:border-b-0 lg:border-r"
                : "hidden shrink-0 border-r border-slate-200 bg-slate-50/70 dark:border-white/10 dark:bg-slate-950/50 lg:block",
              showSidebarOnMobile ? "w-full lg:w-80" : sidebarWidth,
              flush ? "p-0" : "p-5",
            ].join(" ")}
          >
            {sidebar}
          </aside>
        )}

        <main className="min-w-0 flex-1 overflow-hidden">{main}</main>

        {inspector && (
          <aside
            className={[
              showInspectorOnMobile
                ? "fixed inset-x-0 bottom-0 top-12 z-50 overflow-y-auto border-l border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900/60 sm:left-auto sm:w-96 xl:static"
                : "hidden shrink-0 border-l border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900/60 xl:block",
              "shrink-0",
              showInspectorOnMobile ? "w-full sm:w-96" : inspectorWidth,
              flush ? "p-0" : "p-5",
            ].join(" ")}
          >
            {inspector}
          </aside>
        )}
      </div>
    </div>
  );
};

export default FoundryPageShell;
